import React from 'react';
import { HelpCircle } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from './ui/tooltip';

const InfoTooltip = ({ content, side = "top" }) => {
  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>
          <HelpCircle className="h-4 w-4 text-slate-400 hover:text-slate-600 cursor-help inline-block ml-1" />
        </TooltipTrigger>
        <TooltipContent side={side} className="max-w-xs bg-slate-800 text-white p-3">
          <p className="text-sm leading-relaxed">{content}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default InfoTooltip;
